import { ServicesStoreFacade } from '@kaltura-ott/tvpil-shared/lib/facades/services-store-facade';

export const checkIsServiceList = (servicesStore: ServicesStoreFacade) =>
  !!(servicesStore.servicesList?.length && servicesStore.servicesList.length > 1 && !servicesStore.service);
